import { Component } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { RouterService } from 'src/app/core/router.service';
import { environment } from 'src/environments/environment';
import { PopUp } from '../../models';

@Component({
    selector: 'pk-broker-takeover-pop-up-modal',
    templateUrl: './takeover-pop-up-modal.component.html',
    styleUrls: ['./takeover-pop-up-modal.component.scss'],
    standalone: false
})
export class TakeoverPopUpModalComponent {
	// inputs
	public popUp: Subset<PopUp>;

	public environment = environment;

	constructor(
		private activeModal: BsModalRef,
		private routerService: RouterService,
	) {}

	public close(): void {
		this.activeModal.hide();
	}

	public async submit(): Promise<void> {
		this.close();
		await this.routerService.navigate([this.popUp.callToActionDestinationUrl]);
	}
}
